<span class="flex-grow-1"
  ><span *ngIf="name.length">{{ name }}:</span> {{ option }}</span
>
<rrs-icon
  *ngIf="closeable"
  class="ms-1"
  [icon]="iconTypeList.CLOSE"
  size="14"></rrs-icon>
